<template>
  <ValidationProvider v-slot="{ errors }" :name="$attrs.name" :rules="rules">
    <div :style="hidden ? `display: none` : ``">
      <label style="display: block">
        {{ $attrs.label ? $attrs.label : '' }}
      </label>
      <date-picker
        format="DD/MM/YYYY"
        value-type="YYYY-MM-DD"
        placeholder="dd/MM/YYYY"
        lang="en-au"
        v-bind="{ ...$attrs }"
        :value="value"
        :error-messages="errors"
        :disabled="readonly"
        :class="errors.length > 0 ? `has-error` : ``"
        v-on="$listeners"
        @input="emit"
      >
        <template
          v-for="(_, scopedSlotName) in $scopedSlots"
          #[scopedSlotName]="slotData"
        >
          <slot :name="scopedSlotName" v-bind="slotData" />
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
          <slot :name="slotName" />
        </template>
      </date-picker>
    </div>
  </ValidationProvider>
</template>

<script>
import VonexFieldsMixin from '@/mixins/vonexfields.mixin';
export default {
  name: 'VonexDate',
  mixins: [VonexFieldsMixin],
};
</script>

<style scoped>
::v-deep .has-error input {
  background: #ffcbc7;
}
</style>
